<template>
  <div class="transferin">
      <h2>
          {{$t('transferIn')}}
      </h2>
      <div class="content_wrapper">
		  <div class="paySteps">
			  	<p class="stepsTitle">{{$t('paySteps')}}</p>
			  	<p class="stepsContent">{{$t('paySteps1')}}</p>
				<p class="stepsContent">{{$t('paySteps2')}}</p>
				<p class="stepsContent">{{$t('paySteps3')}}</p>
		  </div>
		  <div class="bankInfo">
			  <p class="bankinfoTitle">{{$t('bankTitle')}}</p>
			  <ul class="bankinfoTab">
				  <li :class="[tabActive == 'USD'?'active':'',tabDisabled && tabActive !== 'USD' ? 'tabDisabled':'']" @click="tabChange('USD')">
					USD
				  </li>
				  <li :class="[tabActive == 'EUR'?'active':'',tabDisabled && tabActive !== 'EUR' ? 'tabDisabled':'']" @click="tabChange('EUR')">
					EUR
				  </li>
				  <li :class="[tabActive == 'GBP'?'active':'',tabDisabled && tabActive !== 'GBP' ? 'tabDisabled':'']" @click="tabChange('GBP')">
					GBP
				  </li>
			  </ul>
			  <ul class="bankinfoTabinfo" >
				  <li v-if="tabActive == 'USD'">
					  <ol>
						  <li>
							  <div class="banlinfoleft">
								  ACCOUNT NAME :
							  </div>
							  <div class="banlinforight">
								  EC Markets Group Ltd CLIENT USD
							  </div>
						  </li>
						  <li>
							  <div class="banlinfoleft">
								  ACCOUNT NUMBER :
							  </div>
							  <div class="banlinforight">
								  48854544
							  </div>
						  </li>
						  <li>
							  <div class="banlinfoleft">
								  IBAN/BIC :
							  </div>
							  <div class="banlinforight">
								  GB67BARC20789848854544
							  </div>
						  </li>
						  <li>
							  <div class="banlinfoleft">
								  SORT CODE :
							  </div>
							  <div class="banlinforight">
								  20-78-98
							  </div>
						  </li>
						  <li>
							  <div class="banlinfoleft">
								  BANK ADDRESS :
							  </div>
							  <div class="banlinforight">
								  Barclays Bank, Level 10, 1 Churchill Place, London, E14 5HP
							  </div>
						  </li>
						  <li>
							  <div class="banlinfoleft">
								  SWIFT CODE :
							  </div>
							  <div class="banlinforight">
								  BARCGB22
							  </div>
						  </li>
					  </ol>
				  </li>
				  <li v-if="tabActive == 'EUR'">
					  <ol>
						  <li>
							  <div class="banlinfoleft">
								  ACCOUNT NAME :
							  </div>
							  <div class="banlinforight">
								  EC Markets Group Ltd CLIENT EUR
							  </div>
						  </li>
						  <li>
							  <div class="banlinfoleft">
								  ACCOUNT NUMBER :
							  </div>
							  <div class="banlinforight">
								  82309055
							  </div>
						  </li>
						  <li>
							  <div class="banlinfoleft">
								  IBAN/BIC :
							  </div>
							  <div class="banlinforight">
								  GB30BARC20789882309055
							  </div>
						  </li>
						  <li>
							  <div class="banlinfoleft">
								  SORT CODE :
							  </div>
							  <div class="banlinforight">
								  20-78-98
							  </div>
						  </li>
						  <li>
							  <div class="banlinfoleft">
								  BANK ADDRESS :
							  </div>
							  <div class="banlinforight">
								  Barclays Bank, Level 10, 1 Churchill Place, London, E14 5HP
							  </div>
						  </li>
						  <li>
							  <div class="banlinfoleft">
								  SWIFT CODE :
							  </div>
							  <div class="banlinforight">
								  BARCGB22
							  </div>
						  </li>
					  </ol>
				  </li>
				  <li v-if="tabActive == 'GBP'">
					  <ol>
						  <li>
							  <div class="banlinfoleft">
								  ACCOUNT NAME :
							  </div>
							  <div class="banlinforight">
								  EC Markets Group Ltd CLIENT GBP
							  </div>
						  </li>
						  <li>
							  <div class="banlinfoleft">
								  ACCOUNT NUMBER :
							  </div>
							  <div class="banlinforight">
								  33676285
							  </div>
						  </li>
						  <li>
							  <div class="banlinfoleft">
								  IBAN/BIC :
							  </div>
							  <div class="banlinforight">
								  GB88BARC20789833676285
							  </div>
						  </li>
						  <li>
							  <div class="banlinfoleft">
								  SORT CODE :
							  </div>
							  <div class="banlinforight">
								  20-78-98
							  </div>
						  </li>
						  <li>
							  <div class="banlinfoleft">
								  BANK ADDRESS :
							  </div>
							  <div class="banlinforight">
								  Barclays Bank, Level 10, 1 Churchill Place, London, E14 5HP
							  </div>
						  </li>
						  <li>
							  <div class="banlinfoleft">
								  SWIFT CODE :
							  </div>
							  <div class="banlinforight">
								  BARCGB22
							  </div>
						  </li>
					  </ol>
				  </li>
			  </ul>
		  </div>
          <Form :model="payModel" :rules="rules" class="inputForm" ref="payForm" >
				<FormItem prop="account">
				  <effect-select :label='$t("takeAccount")' :options="accountList" v-model="payModel.account"></effect-select>
				</FormItem>
                <FormItem prop="bankId"  >
                    <effect-select :label='$t("takeBank")' :options="bankList" v-model="payModel.bankId"  :disabled='disabled'></effect-select>
                </FormItem>
                <FormItem  prop="amount">
                    <effect-input  :label='$t("payMoney")'  v-model="payModel.amount"></effect-input>
                </FormItem>
            </Form>
			<Button type="primary" class="formBtn"  @click="ok">{{$t('submit')}}</Button>
      </div>
    <loading :isSpinShow="loading"></loading>
  </div>
</template>

<script>
// @ is an alias to /src
import {mapState} from 'vuex'
import EffectSelect from '@/components/EffectSelect.vue';
import EffectInput from '@/components/EffectInput.vue';
import Loading from '@/components/Loading.vue';


export default {
  name: 'Home',
  components: {
    EffectSelect,
    EffectInput,
    Loading
  },
  data(){
	  const validateAmount = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error(this.$t('fieldError')));
                }
				var reg = /^(\d{0,99})(\.(\d{0,2}))?$/g;
				if (!reg.test(value)) {
					callback(new Error(this.$t('amountCheck')));
				} else {
					callback();
				}
				
               
            };
    return{
        payModel:{
            account:'',
            amount:'',
			bankId:''
        },
		rules:{
			account:[{
				required: true,
				message: this.$t('fieldError')
			}],
			bankId:[{
				required: true,
				message: this.$t('fieldError')
			}],
			amount:[{
				validator: validateAmount,
				trigger: 'blur'
			}]
		},
		bankList: [],
		accountList:[],
		loading: false,
		tabActive:'USD',
		disabled:false,
		checkAccountList:[],
		tabDisabled:false
    }
    
  },
  computed: {
        ...mapState(['lang','userInfo'])
    },
  watch:{ 
		"payModel.account"(val){
			console.log(val)
			this.disabled = false
			var common = this.accountList.filter(function (item) 
			{
				return item.account == Number(val) && item.bankBindID > 0
			})
			// console.log(common)
			if(common.length > 0){
				this.bankList = []
				let data = {
					value:common[0].bankBindID.toString(),
					label:common[0].bankName
				}
				this.bankList.push(data)
				this.payModel.bankId = common[0].bankBindID.toString(),
				this.disabled = true

			}else{
				this.payModel.bankId = ""
				this.$refs.payForm.fields.forEach((v,j) => {
					// console.log(v,j)
					v.validateDisabled = true
					v.validateMessage = ''
					v.validateState = ''
				})
				this.getBank()
			}

			var getCommon = this.accountList.filter(function (item) 
			{
				return item.account == Number(val) 
			})
			this.tabDisabled = true
			this.tabActive = getCommon[0].currency
			if(getCommon[0].sureReadStatus !== 1){
				// let _this = this
				var currencyActive = ''
				if(this.lang == 'zh'){
					if(getCommon[0].currency == 'USD'){
						currencyActive = this.$t('transferInTips1')+this.$t('transferInTipsUSD')+this.$t('transferInTips2')+this.$t('transferInTipsUSD')+this.$t('period')
					}else if(getCommon[0].currency == 'EUR'){
						currencyActive = this.$t('transferInTips1')+this.$t('transferInTipsEUR')+this.$t('transferInTips2')+this.$t('transferInTipsEUR')+this.$t('period')
					}else if(getCommon[0].currency == 'GBP'){
						currencyActive = this.$t('transferInTips1')+this.$t('transferInTipsGBP')+this.$t('transferInTips2')+this.$t('transferInTipsGBP')+this.$t('period')
					}
				}else{
					if(getCommon[0].currency == 'USD'){
						currencyActive = this.$t('transferInTips1')+this.$t('transferInTipsUSD')+this.$t('transferInTips2')+ ' ' +this.$t('transferInTipsUSD')+ ' ' +this.$t('transferInTips3')
					}else if(getCommon[0].currency == 'EUR'){
						currencyActive = this.$t('transferInTips1')+this.$t('transferInTipsEUR')+this.$t('transferInTips2')+ ' ' +this.$t('transferInTipsEUR')+ ' ' +this.$t('transferInTips3')
					}else if(getCommon[0].currency == 'GBP'){
						currencyActive = this.$t('transferInTips1')+this.$t('transferInTipsGBP')+this.$t('transferInTips2')+ ' ' +this.$t('transferInTipsGBP')+ ' ' +this.$t('transferInTips3')
					}
				}
				this.$Modal.warning({
					content: currencyActive,
					okText:this.$t('okText'),
					onOk: () => {
						this.$axios.get('/api/MoneyPay/SureReadDepositNotice?status=1&account='+getCommon[0].account)
						.then(async (res) => {
							if(res.data.status == 1){
								this.getAccount()
							
							}
						})
						.catch((err) => this.$Message.error(err.data.msg))
					}
				});
			}
			// console.log(getCommon)
		}
  },
    created(){
        this.getBank()
        this.getAccount()
    },
    methods:{
        getBank(){
            this.bankList = []
            this.$axios.get('/api/MoneyPay/BankList')
            .then(async (res) => {
                // console.log(res)
                if(res.data.status == 1){
                    res.data.obj.forEach(e => {
                        let data = {
                            value:e.id.toString(),
                            label:e.bankName
                        }
                        this.bankList.push(data)
                    });
                }else{
                    this.$Message.error(res.data.msg)
                }
            })
            .catch((err) => {
                this.$Message.error(err.data.msg)
            })
        },
        getAccount(){
			this.accountList = []
            this.$axios.get('/api/MoneyPay/AccountList')
            .then(async (res) => {
                // console.log(res)
                if(res.data.status == 1){
                    res.data.obj.forEach(e => {
                        // let data = {
                        //     value:e.account.toString(),
                        //     label:e.account
						// }
						e.value = e.account.toString(),
                        e.label = e.account
						this.accountList.push(e)
                    });
                }else{
                    this.$Message.error(res.data.msg)
                }
            })
            .catch((err) => {
                this.$Message.error(err.data.msg)
            })
		},
		tabChange(val){
			if(!this.tabDisabled){
				this.tabActive = val
			}
			
		},
        ok () {
        	this.$refs['payForm'].validate((valid) => {
        		if (valid) {
                    this.loading = true
                    let data = {
                        "mt4Account": Number(this.payModel.account),
                        "amount": Number(this.payModel.amount),
                        "userBankId": Number(this.payModel.bankId),
                    }
        			this.$axios.post('/api/MoneyPay/IssueApplication',data)
        			.then(async (res) => {
        				let dt = res.data
						this.loading = false
        			    if(dt.status == 1){
                            this.$Message.success(dt.msg)
                            this.$refs.payForm.resetFields();
        			    }else{
        			        this.$Message.error(dt.msg)
        			    }
        			}).catch(() => {
						this.loading = false
					})
        		}
        	})
        },
    }
}
</script>
<style lang="less">
.transferin{
    width: 1440px;
    margin: 0 auto;
    height: 100%;
    position: relative;
    h2{
        margin-top: 20px;
        font-weight: normal;
        font-size: 18px;
        color: #332c2b;
        line-height: 50px;
        padding-bottom: 20px;
    }
	.inputForm{
		justify-content: space-between!important;
	}
    .ivu-form-item{
        width: 48%;
    }
	.formBtn{
		min-width: 230px;
	}
	.ivu-form-item-error {
		.ivu-select-selection{
			border: 1px solid #ed4014!important;
		}
	}
	.demo-spin-icon-load{
		animation: ani-demo-spin 1s linear infinite;
	}
	.paySteps{
		padding:2px 30px 30px;
		background: #ffffff;
		border: 1px solid #f0f0f0;
		margin-bottom: 40px;
		border-radius: 4px;
		.stepsTitle{
			color: #332c2b;
			font-size: 16px;
			line-height: 60px;
		}
		.stepsContent{
			font-size: 14px;
			color: #8b8b8c;
		}
	}
	.bankInfo{
		margin-bottom: 40px;
		.bankinfoTitle{
			font-size: 16px;
			color: #332c2b;
			margin-bottom: 20px;

		}
		.bankinfoTab{
			display: flex;
			flex-direction: row;
			font-size: 16px;
			font-weight: bold;
			color: #332c2b;
			
			li{
				padding: 25px 82px;
				cursor: pointer;
				border-radius: 4px;
			}
			li.active{
				background: #ffffff;
				border: 1px solid #f0f0f0;
				border-radius: 4px;
				border-bottom: 0;
			}
			li.tabDisabled{
				cursor: not-allowed;
				color: #8b8b8c;
			}
		}
		.bankinfoTabinfo{
			background: #ffffff;
			border: 1px solid #f0f0f0;
			width: 100%;
			margin-top: -2px;
			border-radius: 4px;
			li{
				ol{
					li{
						display: flex;
						flex-direction: row;
						font-size: 14px;
						line-height: 60px;
						border-bottom: 1px solid #f0f0f0;
						.banlinfoleft{
							width: 20%;
							text-align: right;
							color: #8b8b8c;
							margin-right: 22px;
						}
						.banlinforight{
							text-align: left;
							color: #332c2b;
						}
					}
					li:last-child{
						border-bottom: 0;
					}
				}
			}
		}
	}
	
}

@keyframes ani-demo-spin {
	from { transform: rotate(0deg);}
	50%  { transform: rotate(180deg);}
	to   { transform: rotate(360deg);}
}
</style>
